<template>
    <div>
        <navbar></navbar>
        <img src="../assets/img/findworka-talents.png" class="__climgrtl"/>
        <div class="container">
            <p class="__portpnew">Assembling a Full Product Squad to Launch Riby’s Retailar Platform</p>
            <p class="__headin">The Challenge</p>
            <p class="__meetdname">Riby wanted Retailar to let merchants source products directly from manufacturers, but needed an end-to-end engineering squad—fast.</p>
            
            <p class="__headin">The Solution</p>
            <p class="__meetdname">Findworka deployed a <b class="__namp">Node.js Backend Developer, Flutter Mobile Developer</b> and <b class="__namp">QA Engineer</b> in under two weeks. The team built real-time inventory sync, secure payments, merchant dashboards and analytics.</p>
            <p class="__headin">Services Offered</p>
            <ul class="__portp2new">
                <li>Squad assembly</li>
                <li>Backend</li>
                <li>mobile & QA specialists</li>
                <li>Agile integration</li>
                <li>Ongoing delivery oversight</li>
            </ul>

            <p class="__headin">Impact & Results (tile metrics)</p>
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Merchants Onboarded</span></p>
                        <p class="__meetdname">Hundreds</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Procurement Digitised</span></p>
                        <p class="__meetdname">End-to-end</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">DTime to Market</span></p>
                        <p class="__meetdname">Accelerated</p>
                    </div>
                </div>
            </div><br>

            <p class="__meetdname">Retailar became a lifeline for Nigerian merchants—bypassing middlemen, boosting profit margins and strengthening Riby’s ecosystem.</p>

            <p class="__headin">Tech Stack Deployed</p>
            <ul class="__portp2new">
                <li>Node.js</li>
                <li>Flutter</li>
                <li>MySQL</li>
                <li>Firebase</li>
                <li>Stripe / Paystack integrations</li>
            </ul>

            <p class="__headin">Client Testimonial</p>
            <p class="__meetdname">“Findworka helped us build a capable and reliable team when we needed to move fast. Their engineers integrated smoothly into our system and delivered value with a product-first mindset.” <span class="__namp"><i> — Product Lead, Riby</i></span></p>

            <div class="row">
                <div class="col-xl-2 col-lg-2 col-md-2 col-12"></div>
                <div class="col-xl-8 col-lg-8 col-md-8 col-12">
                    <div class="text-center">
                        <p class="__hvsip">Need top-tier developers reliably and quickly?</p>
                        <p class="__meetdname">Tell us about the roles you’re hiring for, and receive pre-vetted profiles in under 72 hours. Whether you’re looking for individuals or building a team, you’ve come to the right place.</p>
                        <router-link to="/hire" class="btn __viewsite">Get Started Here </router-link>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-12"></div>
            </div>

            <div class="__whitespace"></div>
        </div>
    </div>
</template>


<script>
import navbar from '../components/navbar';

export default {
    components: { navbar },
    data(){
        return{}
    },
}
</script>

<style scoped>
@import '../assets/css/portfolio';
</style>


// WEBPACK FOOTER //
// src/components/talentriby.vue